import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Upload, Row, Col, Form, Input } from "antd";
import Resizer from "react-image-file-resizer";

const UserDetailAvatar = (props) => {
  // -------------------------- VAR --------------------------
  const avatar = props?.avatar || "";
  const disabled = props?.disabled || false;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = (action) => {
    const file = action.file;
    setLoading(true);
    Resizer.imageFileResizer(
      file,
      512,
      512,
      "jpg",
      96,
      0,
      (uri) => {
        setLoading(false);
        props.onSelect(uri);
      },
      "base64"
    );
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  const renderAvatar = () => {
    return (
      <img
        src={avatar}
        alt="avatar"
        style={{
          width: "100%",
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Avatar</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Upload
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        disabled={disabled || loading}
        beforeUpload={beforeUpload}
        customRequest={handleUpload}
      >
        {avatar ? renderAvatar() : renderButton()}
      </Upload>
      <Form.Item style={{ margin: 0 }} name="avatar">
        <Input type="hidden" />
      </Form.Item>
    </>
  );
};

export default UserDetailAvatar;
